export const FP_DATA = 'FDDATA'
export const FP_CARD_META = 'FDCARDMETA'
export const FP_CC_CARD_META = 'FPCCCARDMETA'
export const FP_DC_CARD_META = 'FPDCCARDMETA'
export const FP_SC_CARD_META = 'FPSCCARDMETA'
export const FP_NB_CARD_META = 'FPNBCARDMETA'
export const FP_SET_PAYMENT = 'FPSETPAYMENT'
export const FP_DELETE_SAVED_CARD = 'FPDELETESAVEDCARD'
export const FP_UPI = 'FPUPI'
export const FP_SAVECARD_SUBMID_RESP = 'FPSAVECARDSUBMIDRESP'
export const FP_SC_DEL_RESP = 'FPSCDELRESP'
export const FP_SET_PAY_RESP = 'FPSETPAYRESP'
export const FP_CHANGE_PAYMENT_VIEW = 'FPCHANGEPAYMENTVIEW'
export const GET_MERCHANT_DATA = 'GETMERCHANTDATA'
export const FP_DISABLE_ALL_PAYMENT_MODE = "FPDISABLEALLPAYMENTMODE"
export const FP_TERMS_CONDITION_ACCEPT = "FPTERMSANDCONDTIONACCEPT"
export const FP_SET_TRANSACTION_AMOUNT = "FPSETTRANSACTIONAMOUNT"
export const BHARATHQR_RESPONSE = "BHARATHQR_RESPONSE"

